<template>
    <div>
      <!-- Application Header -->
      <header class="c-main-header-nav">
        <div class="c-responsive-container">
          <div class="c-as-block">
            <div class="c-header-btn-holder">
              <!-- Button when menu is available -->
              <button class="c-burger-button" v-on:click="toggleOffcanvas()"><i class="fa fa-bars" aria-hidden="true"></i></button>
              <!-- Button when menu is NOT available -->
              <!-- <button class="c-burger-button" v-on:click="actionDiscardChanges()" v-else><i class="fa fa-times" aria-hidden="true"></i></button> -->
            </div>
            <!-- Header Title -->
            <div class="c-has-view-title"><b>{{currentViewName}}</b></div>
          </div>
        </div>
      </header>
      <!-- Application Body content -->
      <main class="c-main-body-wrap">
        <div class="c-responsive-container c-relative">
          <!-- #region CONTENT HERE -->          
          <!-- Single Guest to show -->
          <ul class="c-items-list" v-if="listOfWaiters.length > 0">
            <li class="c-single-waiter" v-for="(singleWaiter, index) in listOfWaiters">
              <table class="c-content-as-table">
                <tbody>
                  <tr>
                    <!-- Name Initials -->
                    <td class="c-has-table-number">
                      <div class="c-initials-circle c-md">
                        <!-- Table number -->
                        <span><b>{{returnNameInitials(singleWaiter)}}</b></span>
                      </div>
                    </td>
                    <!-- Text content -->
                    <td class="c-has-guest-name">
                      <div>
                        <span v-if="singleWaiter.lastName"><b>{{singleWaiter.lastName}}</b></span>
                        <span v-if="singleWaiter.firstName"><b>{{singleWaiter.firstName}}</b></span>
                        <span v-if="singleWaiter.nickname"><b>{{singleWaiter.nickname}}</b></span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- Action buttons -->
              <div class="c-has-buttons">
                <button class="c-btn c-btn-action-on-white" v-on:click="openWaiterDetails(singleWaiter)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
              </div>              
            </li>
          </ul>
          <!-- No content message -->
          <emo-well-comp
            v-else
            input-well-type="no-content"
            input-txt-msg="Trenutno nema stalnih gostiju"
          ></emo-well-comp>
          <!-- #endregion CONTENT HERE -->
        </div>
      </main>
      <!-- Application Footer Menu -->
      <footer class="c-main-footer-nav c-footer-without-content">
        <div class="c-responsive-container c-relative">
          <!-- Add New content floating button -->
          <button v-if="glMixin_userAccessCheck(inputFirebaseUser, 'h')"
          class="c-btn c-floating-circle" v-on:click="addNewWaiter()"><i class="fa fa-plus" aria-hidden="true"></i></button>
        </div>
      </footer>
      <!-- Modal Templates -->
      <transition name="slide-up" mode="out-in">
        <component 
          v-if="modalComponent.isVisible" 
          v-bind:is="modalComponent.activeModalComponent"
          v-bind:input-modal-data = "modalComponent.dataForModal"
        ></component>
      </transition>
    </div>
</template>

<script>
import router from '@/router/index'
import EventBus from '@/EventBus'
import FooterNavList from '@/components/footer/FooterNavList'
import EmoWellComp from '@/components/wells/EmoWellComp'
import ModalCreateNewWaiter from '@/components/waiters/ModalCreateNewWaiter'
import ModalWaiterDetails from '@/components/waiters/ModalWaiterDetails'

import {firebaseDB} from '@/firebase';
export default {
  name: 'WaitersList',
  props: ["inputFirebaseUser"],
  components: {
    FooterNavList: FooterNavList,
    EmoWellComp: EmoWellComp,
    ModalCreateNewWaiter: ModalCreateNewWaiter,
    ModalWaiterDetails: ModalWaiterDetails
  },
  data () {
    return {
      // ~ name of current view (component title)
      currentViewName: null,
      // ~ each time we have loading process this array will have length > 0
      isLoading: [],
      // ~ main variable to hold all event items that we want to show on view
      mainListOfWaiters: null,
      // ~ for showing modal
      modalComponent: {
        isVisible: false,
        activeModalComponent: null,
        dataForModal: null
      }
    }
  },
  firebase: function () {
    return {
      listOfWaiters: {
        source: firebaseDB.ref('listOfWaiters'),
        // optionally provide the cancelCallback, if the app client doesn't have permission to read from that database reference
        //cancelCallback: function (error) {console.log('!!! - IMPORTANT - cancelCallback');},
        // this is called once the data has been retrieved from firebase
        readyCallback: function (dataSnapshot) {
          //use Lodash to sort list by date ascending
          this.listOfWaiters = _.orderBy(dataSnapshot.val(), 'firstName', 'asc');
          //          
          this.isLoading.pop();
          //console.log('listOfWaiters dataSnapshot.val(): ' + JSON.stringify(dataSnapshot.val(), null, 2));
        }
      }      
    }
  },   
  methods: {
    // ~ hide offcanvas component inside 'MainApp' component
    toggleOffcanvas: function (){
      EventBus.$emit('toggleOffcanvas');
    },
    ///////////
    returnNameInitials: function (inputGuest) {
      var returnValue = 'XX';
      if (inputGuest && inputGuest.firstName && inputGuest.lastName){
        returnValue = inputGuest.lastName.charAt(0) + inputGuest.firstName.charAt(0);
      }
      //
      return returnValue;
    },      
    /* #region Regular Guest Details Modal */
    // ~ when user wants to change Reservations for some event
    openWaiterDetails: function (inputWaiterItem) {
      // ~ then we need to show different page with wanted event
      var promiseFromModal = this.openModal_WaiterDetails(inputWaiterItem).then(
        function(response){
          //console.log('Modal returned response: ' + JSON.stringify(response, null, 2) );
          // ~ close modal
          this.closeModal();
        }.bind(this),
        function(reject){
          console.log('Modal returned reject');
          // ~ close modal
          this.closeModal();
        }.bind(this)
      );
    },
    openModal_WaiterDetails: function (inputWaiterItem) {
      return new Promise ((resolve, reject)=>{
        this.modalComponent.activeModalComponent = ModalWaiterDetails;
        this.modalComponent.isVisible = true;
        this.modalComponent.dataForModal = {
            headerTitle: 'Event Reservations Title',
            dataForModal: {
              selectedWaiter: inputWaiterItem
            },
            resolve: resolve,
            reject: reject
        }
      });
    },    
    /* #endregion Regular Guest Details Modal */
    /* #region Regular Guest Spendings Modal */
    // ~ when user wants to change Reservations for some event
    addNewWaiter: function () {
      // ~ then we need to show different page with wanted event
      var promiseFromModal = this.openModal_AddNewWaiter().then(
        function(response){
          //console.log('Modal returned response: ' + JSON.stringify(response, null, 2) );
          // ~ close modal
          this.closeModal();
        }.bind(this),
        function(reject){
          console.log('Modal returned reject');
          // ~ close modal
          this.closeModal();
        }.bind(this)
      );
    },
    openModal_AddNewWaiter: function () {
      return new Promise ((resolve, reject)=>{
        this.modalComponent.activeModalComponent = ModalCreateNewWaiter;
        this.modalComponent.isVisible = true;
        this.modalComponent.dataForModal = {
            headerTitle: 'New Waiter Title',
            dataForModal: null,
            resolve: resolve,
            reject: reject
        }
      });
    },    
    /* #endregion Regular Guest Spendings Modal */     
    closeModal: function (){
      this.modalComponent.isVisible = false;
      this.modalComponent.activeModalComponent = null;
      this.modalComponent.dataForModal = null;
    }    
  },
  created () {
    //console.log('~ created- WaitersList component!');
    // ~ once we created this view, we must call api to get list of all Regular Guests
    // ~ call action when router is ready
    this.$router.onReady(function () {
      if (this.$route.meta) {
        this.currentViewName = this.$route.meta.headerTitle
      }
    }.bind(this));
  },
  mounted () {
    //console.log('~ mounted - WaitersList component!');
  },
  destroyed () {
    //console.log('~ destroyed- WaitersList component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/waiters/WaitersList.vue